module.exports = __webpack_public_path__ + "static/put-first-webhook-0bfe972ba264738b9f7539ffc82278a4.png";